// extracted by mini-css-extract-plugin
export default {"root":"jPlBtOMc1L"};